import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import Button from '../../../../FlyfishComponents/Button';
import { Tooltip } from '@mui/material';
import { GenericVideo, PlayIcon } from '../svg';
import { getImg } from '../../../../../Utils/getImg';

const ICDiv = styled.div<{ type: string }>`
	cursor: pointer;
	height: ${(props) => (props.type === 'video' ? '275px' : '260px')};
	max-width: 500px;
	margin-right: 10px;
	&.displayCount-3 {
		width: 33%;
	}
	&.displayCount-2 {
		max-width: 494px;
		width: 50%;
	}
	&.displayCount-1 {
		height: unset;
		width: 100%;
		display: flex;
		max-width: unset;
		border: unset;
		border-radius: unset;
		& > .image-video {
			height: unset;
			border-bottom: unset;
			& > img {
				width: 100%;
				max-height: ${(props) => (props.type === 'video' ? '159px' : '164px')};
				border-radius: 11px;
				object-fit: cover;
				min-width: 318px;
				height: 100%;
				border: 1px solid #7070702e;
			}
			& > svg {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}
	border: 1px solid #b9b9b982;
	border-radius: 11px;
	& > .image-video {
		height: 75%;
		position: relative;
		border-bottom: 1px solid #b9b9b982;
		& > img {
			width: 100%;
			max-height: ${(props) => (props.type === 'video' ? '159px' : '207px')};
			border-top-right-radius: 11px;
			border-top-left-radius: 11px;
			object-fit: cover;
			height: 100%;
		}
		& > svg {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}
`;

const ICDescDiv = styled.div`
	padding: 15px;
	height: 40%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	&.displayCount-1 {
		height: unset;
		padding: unset;
		padding-left: 25px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		max-height: 164px;
	}
	& > .tooltip-wrapper {
		text-align: left;
	}
	& .ff-chatbot-body1 {
		font-weight: bold;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
	}
	& .description {
		overflow: hidden;
		margin: 10px 0 !important;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
	}
	& > .custom-button {
		& > button {
			background: #ffb100 !important;
			border-radius: 9px !important;
			padding: 18px 13px !important;
			color:#000 !important;
			margin-top: -7px;
			& > div {
				color: black !important;
			}
		}
	}
	& > .channel-duration {
		display: flex;
		align-items: center;
		gap: 15px;
		& > .channel {
			display: flex;
		}
	}
`;
type Props = {
	URL: string;
	heading: string;
	desc?: string;
	readMoreUrl?: Function;
	type?: string;
	displayCardCount?: number;
};

const ImageCards = ({
	URL,
	heading,
	desc,
	readMoreUrl,
	type,
	displayCardCount,
}: Props) => {
	const [videoChannel, setVideoChannel] = useState('');
	// useEffect(() => {
	// 	if (readMoreUrl.indexOf('youtube.com') > -1) {
	// 		setVideoChannel('youtube');
	// 	} else if (readMoreUrl.indexOf('vimeo.com') > -1) {
	// 		setVideoChannel('vimeo');
	// 	} else {
	// 		setVideoChannel('video');
	// 	}
	// }, []);
	return (
		<ICDiv
			onClick={() => readMoreUrl}
			type={type}
			className={`displayCount-${displayCardCount} parent  ff-card-carousel`}
		>
			<div className='image-video'>
				<img src={URL} alt='' />
				{type === 'video' ? <PlayIcon /> : null}
			</div>
			<ICDescDiv className={`displayCount-${displayCardCount} child`}>
				<div>
					<Tooltip title={heading.toLocaleUpperCase()}>
						<p className='ff-chatbot-body1' style={{ textTransform: 'capitalize' }}>{heading}</p>
					</Tooltip>
					{/* <Tooltip title={desc}> */}
					<p className='description'>{desc}</p>
					{/* </Tooltip> */}
				</div>
				{type === 'video' ? (
					<div className='channel-duration'>
						<div className='channel'>
							{videoChannel === 'youtube' ? (
								<img src={getImg('youtube.png')} alt='' />
							) : (
								<GenericVideo />
							)}
						</div>
						<div className='ff-chatbot-caption'>1 min 27 sec</div>
						<div className='ff-chatbot-caption'>Jul 26, 2023</div>
					</div>
				) : (
					null
					// <Button onClick={() => readMoreUrl()}>Know More</Button>
				)}
			</ICDescDiv>
		</ICDiv>
	);
};

export default ImageCards;
